import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Typography,
  Button,
  message,
  Divider,
  Table,
  Input,
  Tooltip,
  Form,
  Modal,
  Select,
  Space,
  InputNumber,
  DatePicker,
  Alert,
  Dropdown,
} from "antd";
import {
  EditOutlined,
  SearchOutlined,
  PlusOutlined,
  DeleteOutlined,
  ReadOutlined,
  ClockCircleOutlined,
  UsergroupAddOutlined,
  CheckOutlined,
  StopOutlined,
  SettingOutlined,
  UserAddOutlined,
  AppstoreAddOutlined,
  BarChartOutlined,
} from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useParams } from "react-router-dom";
import http from "../../../services/http";
import dayjs from "dayjs";
import { maskMoney } from "../../../helpers/masks";
const { Text } = Typography;

// STATUS
const options_status = [
  { value: 0, label: "Inativo" },
  { value: 1, label: "Ativo" },
];

// OBRIGATORIO
const options_obrigatorio = [
  { value: 0, label: "Não" },
  { value: 1, label: "Sim" },
];

// TODOS
const options_todos = [
  { value: 0, label: "Personalizado" },
  { value: 1, label: "Todos" },
];

// TIPO
const options_tipo = [
  { value: 1, label: "Curso Online (Autoestudo)" },
  { value: 2, label: "Curso Interativo (Online ou Presencial)" },
];

const array_tipo = ["Curso Online (Autoestudo)", "Curso Interativo (Online ou Presencial)"];

// TIPO DSCRIÇÃO
const options_tipo_descricao = [
  "Curso com modulos e trilha de aprendizagem, realizado pelo próprio colaborador.",
  "Curso interativo realizado de forma online ou presencial, sem trilha de aprendizagem.",
];

export const CadTreinamentos = () => {
  const { id_grupo } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [modal, contextHolder] = Modal.useModal();

  // ID ALTERAÇÃO
  const [idAlt, setIdAlt] = useState(0);
  const [search, setSearch] = useState("");
  const [tipo, setTipo] = useState(null);

  // DADOS
  const [grupo, setGrupo] = useState({});
  const [optionsClassificacoes, setOptionsClassificacoes] = useState([]);

  useEffect(() => {
    if (id_grupo > 0) {
      carregarGrupo(id_grupo);
      listarCursos(id_grupo);
      carregarClassificacoes();
    }
  }, [id_grupo]);

  // CARREGAR GRUPO
  const carregarGrupo = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/treinamentos_grupos/carregar/${id}`, []);

    if (api.statusCode === 200) {
      setGrupo(api?.response?.data);
    } else {
      navigate("/treinamentos/grupos");
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CARREGAR CLASSIFICAÇÕES
  const carregarClassificacoes = async () => {
    setLoading(true);
    const api = await http("get", `v1/treinamentos_classificacao/listar_ativos`, []);
    if (api.statusCode === 200) {
      const response = api?.response?.data;
      let array_classificacoes = [];

      response?.forEach((e) => {
        array_classificacoes.push({ value: e?.id, label: e?.descricao });
      });

      setOptionsClassificacoes(array_classificacoes);
    } else {
      navigate("/treinamentos/grupos");
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // LISTAR
  const listarCursos = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/treinamentos_cursos/listar/${id}`, []);
    if (api.statusCode === 200) {
      setDados(api.response.data);
    } else {
      navigate("/treinamentos/grupos");
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CADASTRAR
  const cadastrarCurso = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/treinamentos_cursos/adicionar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registro cadastrado com sucesso!");
      setShowModal(false);
      resetForm();
      listarCursos(id_grupo);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // ALTERAR
  const alterarCurso = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/treinamentos_cursos/alterar`, formulario);
    if (api.statusCode === 200) {
      message.success("Registro alterado com sucesso!");
      setShowModal(false);
      resetForm();
      listarCursos(id_grupo);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CARREGAR
  const carregarCurso = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/treinamentos_cursos/carregar/${id}`, []);

    if (api.statusCode === 200) {
      const response = api?.response?.data;

      setShowModal(true);
      resetForm();
      setTipo(response?.tipo);
      form.setFieldsValue({
        id_treinamentos_cad_classificacao: response.id_treinamentos_cad_classificacao,
        descricao: response.descricao,
        carga_horaria: response.carga_horaria,
        media_aprovacao: response.media_aprovacao,
        observacoes: response.observacoes,
        obrigatorio: response.obrigatorio,
        data_inicio: dayjs(response.data_inicio),
        data_fim: dayjs(response.data_fim),
        tipo: response.tipo,
        todos_filiais: response.todos_filiais,
        todos_setores: response.todos_setores,
        todos_cargos: response.todos_cargos,
        codigo_conclusao: response.codigo_conclusao,
        status: response.status,
      });
      setIdAlt(api.response.data.id);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // DELETAR
  const deletarCurso = async (id) => {
    setLoading(true);
    const api = await http("post", `v1/treinamentos_cursos/deletar`, { id: id });
    if (api.statusCode === 200) {
      message.success("Registro deletado com sucesso!");
      listarCursos(id_grupo);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // RESET FORM
  const resetForm = () => {
    form.resetFields();
    setIdAlt(0);
    setTipo(null);
  };

  // COLUNAS TABLE
  const columns = [
    {
      title: "Descrição",
      dataIndex: "descricao",
      sorter: (a, b) => a.descricao?.localeCompare(b.descricao),
    },
    {
      title: "Carga Horaria",
      dataIndex: "carga_horaria",
      render: (_, e) => e?.carga_horaria + " minutos",
      sorter: (a, b) => a.carga_horaria?.toString()?.localeCompare(b.carga_horaria?.toString()),
    },
    {
      title: "Tipo",
      dataIndex: "tipo",
      render: (_, e) => array_tipo[e?.tipo - 1],
      sorter: (a, b) => array_tipo[a?.tipo - 1]?.localeCompare(array_tipo[b?.tipo - 1]),
    },
    {
      title: "Código",
      dataIndex: "codigo_conclusao",
      sorter: (a, b) => a.codigo_conclusao?.toString()?.localeCompare(b.codigo_conclusao?.toString()),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (_, e) => (e.status === 1 ? "Ativo" : "Inativo"),
      sorter: (a, b) => (a.status === 1 ? "Ativo" : "Inativo")?.localeCompare(b.status === 1 ? "Ativo" : "Inativo"),
    },
    {
      title: "Ações",
      width: 150,
      render: (_, e) => {
        const items = [
          e.todos_cargos === 0 && {
            label: "Liberações Cargos",
            key: "1",
            icon: <CheckOutlined />,
            onClick: () => navigate(`/treinamentos/grupos/cursos/${id_grupo}/cargos/${e?.id}`),
          },
          e.todos_setores === 0 && {
            label: "Liberações Setores",
            key: "2",
            icon: <CheckOutlined />,
            onClick: () => navigate(`/treinamentos/grupos/cursos/${id_grupo}/setores/${e?.id}`),
          },
          e.todos_filiais === 0 && {
            label: "Liberações Filiais",
            key: "3",
            icon: <CheckOutlined />,
            onClick: () => navigate(`/treinamentos/grupos/cursos/${id_grupo}/filiais/${e?.id}`),
          },
          {
            label: "Liberações Usuários",
            key: "4",
            icon: <CheckOutlined />,
            onClick: () => navigate(`/treinamentos/grupos/cursos/${id_grupo}/colaboradores-liberacao/${e?.id}`),
          },
          {
            label: "Bloqueios Usuários",
            key: "5",
            icon: <StopOutlined />,
            onClick: () => navigate(`/treinamentos/grupos/cursos/${id_grupo}/colaboradores-bloqueio/${e?.id}`),
          },
          {
            label: "Responsáveis",
            key: "6",
            icon: <UserAddOutlined />,
            onClick: () => navigate(`/treinamentos/grupos/cursos/${id_grupo}/responsaveis/${e?.id}`),
          },
        ].filter((i) => i !== false);

        return (
          <Space.Compact>
            {e?.tipo === 1 && (
              <Tooltip title="Módulos">
                <Button
                  loading={loading}
                  onClick={() => navigate(`/treinamentos/grupos/cursos/${id_grupo}/modulos/${e?.id}`)}
                  icon={<AppstoreAddOutlined />}
                />
              </Tooltip>
            )}
            <Tooltip title="Relatório">
              <Button
                loading={loading}
                onClick={() => navigate(`/treinamentos/grupos/cursos/${id_grupo}/relatorio/${e?.id}`)}
                icon={<BarChartOutlined />}
              />
            </Tooltip>

            <Dropdown menu={{ items }}>
              <Button loading={loading} icon={<SettingOutlined />} />
            </Dropdown>

            <Tooltip title="Editar">
              <Button loading={loading} onClick={() => carregarCurso(e.id)} icon={<EditOutlined />} />
            </Tooltip>
            <Tooltip title="Excluir">
              <Button
                loading={loading}
                icon={<DeleteOutlined />}
                onClick={() => {
                  modal.confirm({
                    title: "Deseja deletar este registro?",
                    okText: "Sim",
                    cancelText: "Cancelar",
                    onOk() {
                      deletarCurso(e.id);
                    },
                  });
                }}
              />
            </Tooltip>
          </Space.Compact>
        );
      },
      dataIndex: "acoes",
    },
  ];

  // SUBMIT FORM
  const onSubmit = (formulario) => {
    formulario.id_treinamentos_cad_grupos = id_grupo;

    formulario.data_inicio = dayjs(formulario.data_inicio).format("YYYY-MM-DD");
    formulario.data_fim = dayjs(formulario.data_fim).format("YYYY-MM-DD");

    if (idAlt > 0) {
      formulario.id = idAlt;
      alterarCurso(formulario);
    } else {
      cadastrarCurso(formulario);
    }
  };

  // PESQUISAR
  const handleFilter = (pesquisar) => {
    let filteredData = dados?.filter(
      (val) =>
        val.descricao?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        maskMoney(val?.carga_horaria)?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        val.codigo_conclusao?.toString()?.toLowerCase().includes(pesquisar.toLowerCase()) ||
        array_tipo[val?.tipo - 1]?.toString()?.toLowerCase().includes(pesquisar.toLowerCase())
    );
    return filteredData;
  };

  const dadosFilter = dados?.length > 0 ? handleFilter(search) : [];

  // FORMULÁRIO
  const modalFormulario = () => {
    return (
      <Modal
        title={
          <Text style={{ fontSize: 20 }}>
            <EditOutlined /> {idAlt > 0 ? "Editar" : "Adicionar"} Curso/Treinamento
          </Text>
        }
        open={showModal}
        onOk={() => form.submit()}
        okText="Salvar"
        width={1200}
        okButtonProps={{ size: "large", loading: loading }}
        cancelButtonProps={{ size: "large", loading: loading }}
        onCancel={() => {
          setShowModal(false);
          resetForm();
        }}>
        <Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="descricao"
                label="Descrição"
                rules={[{ required: true, message: "Digite a descrição!" }]}>
                <Input size="large" disabled={loading} placeholder="Informe a descrição" />
              </Form.Item>
            </Col>
            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="carga_horaria"
                label="Carga Horaria"
                rules={[{ required: true, message: "Digite a carga horaria!" }]}>
                <InputNumber
                  min={1}
                  size="large"
                  max={1000000}
                  addonBefore={<ClockCircleOutlined />}
                  addonAfter="Minutos"
                  disabled={loading}
                  placeholder="Informe a carga horaria!"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="media_aprovacao"
                label="Média Aprovação"
                rules={[{ required: true, message: "Informe a média!" }]}>
                <InputNumber
                  min={0}
                  size="large"
                  step={0.5}
                  max={10}
                  decimalSeparator=","
                  precision={2}
                  disabled={loading}
                  placeholder="Informe a carga horaria!"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="obrigatorio"
                label="Obrigatório"
                rules={[{ required: true, message: "Selecione uma opção!" }]}>
                <Select
                  size="large"
                  placeholder="Selecione uma opção"
                  disabled={loading}
                  style={{ width: "100%" }}
                  options={options_obrigatorio}
                />
              </Form.Item>
            </Col>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="id_treinamentos_cad_classificacao"
                label="Classificação"
                rules={[{ required: true, message: "Selecione a classificação!" }]}>
                <Select
                  size="large"
                  placeholder="Selecione a classificação"
                  disabled={loading}
                  style={{ width: "100%" }}
                  options={optionsClassificacoes}
                />
              </Form.Item>
            </Col>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="status" label="Status" rules={[{ required: true, message: "Selecione o status!" }]}>
                <Select
                  size="large"
                  placeholder="Selecione o status"
                  disabled={loading}
                  style={{ width: "100%" }}
                  options={options_status}
                />
              </Form.Item>
            </Col>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="tipo" label="Tipo" rules={[{ required: true, message: "Selecione o tipo!" }]}>
                <Select
                  size="large"
                  placeholder="Selecione o tipo"
                  value={tipo}
                  onChange={(e) => setTipo(e)}
                  disabled={loading}
                  style={{ width: "100%" }}
                  options={options_tipo}
                />
              </Form.Item>

              {tipo && <Alert description={options_tipo_descricao[tipo - 1]} type="info" showIcon />}
            </Col>

            <Col className="gutter-row" span={24}>
              <Form.Item
                name="observacoes"
                label="Observações"
                rules={[{ required: true, message: "Informe as observações!" }]}>
                <Input.TextArea
                  size="large"
                  disabled={loading}
                  placeholder="Informe as observações"
                  rows={6}
                  autoSize={{ minRows: 5, maxRows: 7 }}
                />
              </Form.Item>
            </Col>

            <Divider orientation="left">
              <ClockCircleOutlined /> Período Realização
            </Divider>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="data_inicio"
                label="Data Início"
                rules={[{ required: true, message: "Selecione a data!" }]}>
                <DatePicker format="DD/MM/YYYY" style={{ width: "100%" }} size="large" disabled={loading} />
              </Form.Item>
            </Col>
            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="data_fim" label="Data Fim" rules={[{ required: true, message: "Selecione a data!" }]}>
                <DatePicker format="DD/MM/YYYY" style={{ width: "100%" }} size="large" disabled={loading} />
              </Form.Item>
            </Col>

            <Divider orientation="left">
              <UsergroupAddOutlined /> Liberação Acessos
            </Divider>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="todos_filiais"
                label="Filiais"
                rules={[{ required: true, message: "Selecione uma opção!" }]}>
                <Select
                  size="large"
                  placeholder="Selecione uma opção"
                  disabled={loading}
                  style={{ width: "100%" }}
                  options={options_todos}
                />
              </Form.Item>
            </Col>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="todos_setores"
                label="Setores"
                rules={[{ required: true, message: "Selecione uma opção!" }]}>
                <Select
                  size="large"
                  placeholder="Selecione uma opção"
                  disabled={loading}
                  style={{ width: "100%" }}
                  options={options_todos}
                />
              </Form.Item>
            </Col>

            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                name="todos_cargos"
                label="Cargos"
                rules={[{ required: true, message: "Selecione uma opção!" }]}>
                <Select
                  size="large"
                  placeholder="Selecione uma opção"
                  disabled={loading}
                  style={{ width: "100%" }}
                  options={options_todos}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  };

  return (
    <Row align="middle" justify="center" className="content-row">
      {modalFormulario()}
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Treinamentos & Desenvolvimento" onClickBack={() => navigate("/treinamentos/grupos")} />
            <HeaderTitle
              title={["Treinamentos & Desenvolvimento", "Grupos", "Treinamentos"]}
              subtitle={<Text italic>{grupo?.descricao ?? ""}</Text>}
              icon={<ReadOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Space wrap>
                <Input
                  size="middle"
                  maxLength={100}
                  prefix={<SearchOutlined />}
                  className="input"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Pesquisar..."
                  allowClear
                />
                <Tooltip title="Adicionar Registro">
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => {
                      setShowModal(true);
                      resetForm();
                    }}
                    loading={loading}>
                    Novo
                  </Button>
                </Tooltip>
              </Space>

              <Divider />

              <Table
                rowKey="id"
                loading={loading}
                scroll={{ x: 700 }}
                columns={columns}
                dataSource={dadosFilter}
                size="small"
              />
            </Card>
          </div>
        </Col>
      </Col>
      {contextHolder}
    </Row>
  );
};
